import { InnerErrorResponse } from "./inner-error-response.model";

export interface ErrorResponse {
    code?: string;
    message?: string;
    target?: string;
    details?: ErrorResponse[];
    innerError?: InnerErrorResponse;
}
